import React from 'react'
const Typography = React.lazy(() => import('@material-ui/core/Typography'));
import { Link } from 'react-router-dom';
import {INVOICE_LIST} from '~/router/routes';
import {generatePath} from 'react-router';
import { connect } from 'react-redux'
import { Layout } from '@components/layout'
import './style.css'

class CompanyLockPageComponent extends React.Component {

    componentDidMount(){
        this.props.closePreloader();
    }

    render() {
        let days = '';
        let daysLeft = this.props.daysLeft * -1;

        if (daysLeft === 1) {
            days = `${daysLeft} день`;
        } else if (daysLeft < 5) {
            days = `${daysLeft} дня`;
        } else {
            days = `${daysLeft} дней`;
        }

        return (
            <div className={'lock-page'}>
                <Typography align='center' variant='h5'>{`Тариф компании закончился ${days} назад.`}</Typography>
                <Typography align='center' variant='h6'>Пожалуйста, продлите Ваш тариф.</Typography>
                <br/>
                <Link style={{cursor: 'pointer', textDecoration: 'none'}} to={generatePath(INVOICE_LIST)}>
                    Продлить тариф
                </Link>
                <div className="lock-wrapper">
                    <div className="base">
                        <div className="base-bottom">
                        </div>
                        <div className="lock-inside-top">
                        </div>
                        <div className="lock-inside-bottom">
                        </div>
                    </div>
                    <div className="lock-cirlce">
                        <div className="lock-circle-inside">
                        </div>
                    </div>
                    <div className="lock-box">
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({});

const actions = {
    closePreloader: Layout.actions.closePreloader
};

export default connect(mapStateToProps, actions)(CompanyLockPageComponent);
